module.exports = __webpack_public_path__ + "static/img/wanted1.2d77d28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/wanted1.png
// module id = L0DT
// module chunks = 1 3